import { Platform } from "react-native"
import CustomizeCompsScreen from "@/screens/CustomizeCompsScreen"
import CustomizeCompsScreenWeb from "@/screens/CustomizeCompsRedirectScreen"

let CustomCompScreen: () => null | JSX.Element = CustomizeCompsScreen

if (Platform.OS === "web") {
  CustomCompScreen = CustomizeCompsScreenWeb
}

export default CustomCompScreen
